import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { CDropDown } from "@appcues/component-library";
import { selectFlows } from "reducers/account/flows";
import { STEP_TYPE_IDS } from "constants/stepTypes";

const { REDIRECT, WAIT_FOR_PAGE } = STEP_TYPE_IDS;

export const SelectStepGroup = ({ value, options = [], onChange }) => {
  const dropdownOptions = options.concat(
    value && !options.some(({ value: optValue }) => optValue === value)
      ? {
          label: value,
          value
        }
      : []
  );

  return (
    <CDropDown
      value={value}
      placeholder="Select a Flow Step"
      options={dropdownOptions}
      isDisabled={dropdownOptions.length < 1}
      isSearchable
      minWidth="22em"
      onChange={onChange}
    />
  );
};

SelectStepGroup.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string
    })
  ),
  value: PropTypes.string,
  onChange: PropTypes.func
};

const mapStateToProps = state => ({
  options: Object.values(selectFlows(state))
    .sort((a, b) => (a.name || a.id).localeCompare(b.name || b.id))
    .map(({ name, id, steps = {} }) =>
      Object.values(steps)
        .filter(({ type }) => ![REDIRECT, WAIT_FOR_PAGE].includes(type))
        .sort((a, b) => a.index - b.index)
        .map(({ id: value, index }) => ({
          label: `${name || id} (Step ${index + 1})`,
          value
        }))
    )
    // we really want a flatMap on selectFlows, but can't do that in Node < 11
    .reduce((acc, steps) => acc.concat(steps), [])
});

export default connect(mapStateToProps)(SelectStepGroup);
